export enum OwaConnectedAccountInitSource {
    Add,
    Init,
}
